import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';

import { Button } from '@material-ui/core';
import { useNavButtonStyles } from './ConsentDocumentBody';

export const QuestionnaireButton = () => {

    const navButtonClasses = useNavButtonStyles();
    const [toQuestionnaire, setToQuestionnaire] = useState(false);

    const handleClick = () => {
        setToQuestionnaire(true);
    }

    if (toQuestionnaire) {
        return <Redirect to="/questionnaire" />;
    }

    return (
        <Button
            color="primary"
            fullWidth={false}
            className={`${navButtonClasses.navButton} ${navButtonClasses.navButtonPrimary}`}
            onClick={handleClick}>
            Frågeformulär
        </Button>
    );
}